import { AsyncAction } from "actions/types";
import { getResource } from "selectors/resources";

export function dismissWindowAlertAction(): {type: string} {
  return {
    type: "DISMISS_WINDOW_ALERT"
  };
}

interface WindowAlertEventData {
  type: unknown;
  title: unknown;
  content: unknown;
  image: unknown;
  clients: unknown;
  action_required: unknown;
}

function generateWindowAlert(eventData: WindowAlertEventData): AsyncAction {
  return (dispatch, getState) => {
    dispatch({
      type: "GENERATE_WINDOW_ALERT",
      title: eventData.title || null,
      content: eventData.content || null,
      image: eventData.image || null,
      clients: eventData.clients || [],
      actionRequired: eventData.action_required,
      currentClient: getResource(getState(), "client"),
      windowAlertType: eventData.type || null
    });
  };
}

export function createWindowAlert(eventData: WindowAlertEventData): AsyncAction {
  return (dispatch, getState) => {
    // Ignore alert if another alert is already open
    if (!getState().windowAlert.get("isVisible")) {
      dispatch(generateWindowAlert(eventData));
    }
  };
}
